export class ProjectProgress {
  progressPercentage: number;
  incidencePercentage: number;
  responsePercentage: number;
  completeCount: number;
  reviewRequiredCount: number;
  invitationCount: number;
}
